/* PlayMaster IA — Online/Offline detection hook + helpers. */
import { useEffect, useState } from 'react';

export function useOnline() {
  const [online, setOnline] = useState(() => {
    if (typeof navigator === 'undefined') return true;
    return navigator.onLine;
  });
  useEffect(() => {
    const onUp = () => setOnline(true);
    const onDown = () => setOnline(false);
    window.addEventListener('online', onUp);
    window.addEventListener('offline', onDown);
    return () => {
      window.removeEventListener('online', onUp);
      window.removeEventListener('offline', onDown);
    };
  }, []);
  return online;
}

export function isOffline() {
  return typeof navigator !== 'undefined' && navigator.onLine === false;
}
